import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';

@Component({
  selector: 'g10-route-configuration',
  templateUrl: './route-configuration.component.html',
  styleUrls: ['./route-configuration.component.css']
})
export class RouteConfigurationComponent implements OnInit {
  searchedValue = '';
  searchKey = 'name'
  configName = [];
  searchText: string;
  public searchInput: any = new Subject<string>();

  public configModule = [
    {
      name: 'Route Cutoff',
      icon: 'assets/images/rostering/configuration/route-cutoff.png',
      path: `route-cutoff`,
      disabled:false,
    },
    // {
    //   name: 'Holiday',
    //   icon: 'assets/images/rostering/configuration/holiday2.png',
    //   path: 'holiday',
    //   disabled:false,
    // },   
  ];
  constructor(public router: Router) {
  }

  ngOnInit(): void {
    this.getConfigName();
  }
  selectReportData(data) {
    // console.log(this.configName.includes(data.name), data)
    if (this.configName.includes(data.name)) {
      this.router.navigate([`/organization/transport-manager/rostering/manage-route/configuration/${data.path}`]);
    }

  }
  getConfigName() {
    this.configModule.forEach(element => {
      this.configName.push(element.name);
    });
  }

}